import React from 'react'
import { Heading } from 'particles'
export default props => <Heading {...props} />


// WEBPACK FOOTER //
// ./src/interface/atomic/atoms/Heading/index.js